import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Image } from '@mui/icons-material';

interface Props {
  url: string;
}

export const ImageViewer = ({ url }: Props) => {
  const classes = useStyles();

  if (!url) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '10rem',
          display: 'flex',
          borderRadius: 2,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#ECEFF1',
        }}
      >
        <Image />
      </Box>
    );
  }

  return <Box component="img" alt={`image-${url}`} src={url} className={classes.mainImage} />;
};

const useStyles = makeStyles({
  mainImage: {
    width: '100%',
    borderRadius: 4,
    height: '10rem',
    objectFit: 'cover',
    transition: 'opacity 0.4s ease',
  },
});
